import { IACoverageType } from "./IACoverageType";

export const basicCoverage: IACoverageType = {
  abbr: "BA",
  i18nKey: "common:ew_coverage_type_basic",
};

export const prefferedCoverage: IACoverageType = {
  abbr: "PR",
  i18nKey: "common:ew_coverage_type_preferred",
};

export const classicCoverage: IACoverageType = {
  abbr: "CL",
  i18nKey: "common:ew_coverage_type_classic",
};

export const superiorCoverage: IACoverageType = {
  abbr: "SU",
  i18nKey: "common:ew_coverage_type_superior",
};

export const superiorWrapCoverage: IACoverageType = {
  abbr: "SW",
  i18nKey: "common:ew_coverage_type_superior_wrap",
};

export const limitedPowertrain: IACoverageType = {
  abbr: "LI",
  i18nKey: "common:ew_coverage_type_essential",
};

export const powertrain3: IACoverageType = {
  abbr: "P3",
  i18nKey: "common:ew_coverage_type_essential",
};

export const powertrain5: IACoverageType = {
  abbr: "P5",
  i18nKey: "common:ew_coverage_type_essential",
};

export const fiveHundred: IACoverageType = {
  abbr: "AM",
  i18nKey: "common:ew_coverage_type_ama",
};

export const sevenHundredFifty: IACoverageType = {
  abbr: "L2",
  i18nKey: "common:ew_coverage_type_ama",
};

export const oneThousandTwoHundredFifty: IACoverageType = {
  abbr: "AA",
  i18nKey: "common:ew_coverage_type_ama",
};

export const twoThousandFiveHundred: IACoverageType = {
  abbr: "AB",
  i18nKey: "common:ew_coverage_type_ama",
};

export const fiveThousand: IACoverageType = {
  abbr: "MA",
  i18nKey: "common:ew_coverage_type_ama",
};

export const sevenThousandFiveHundred: IACoverageType = {
  abbr: "BB",
  i18nKey: "common:ew_coverage_type_ama",
};

export const tenThousand: IACoverageType = {
  abbr: "CC",
  i18nKey: "common:ew_coverage_type_ama",
};

export const IAExtendedWarrantyCoverageTypes: IACoverageType[] = [
  basicCoverage,
  prefferedCoverage,
  classicCoverage,
  limitedPowertrain,
  powertrain3,
  powertrain5,
  superiorCoverage,
  superiorWrapCoverage,
  fiveHundred,
  sevenHundredFifty,
  oneThousandTwoHundredFifty,
  twoThousandFiveHundred,
  fiveThousand,
  sevenThousandFiveHundred,
  tenThousand,
];

export function getCoverageByAbbr(abbr: string): IACoverageType | undefined {
  return IAExtendedWarrantyCoverageTypes.find(
    (coverage) => coverage.abbr === abbr
  );
}

// only needed until these coverages have brochure
export function hasBrochure(abbr: string): boolean {
  return abbr !== powertrain3.abbr && abbr !== powertrain5.abbr;
}
